import { RouteConfig } from 'vue-router';

import MedicalExamination from '@/views/profile/MedicalExamination.vue';

export function profileMedicalExaminationRoute(name: string): RouteConfig {
  return {
    path: 'medicalExamination',
    name,
    component: MedicalExamination,
    meta: {
      title: 'titles.profile.medicalExamination'
    },
    beforeEnter: (to: any, from: any, next: any) => {
      if (!to.query.order) {
        next({ name: to.name, params: to.params, query: { order: 'end', desc: true } });
      } else {
        next();
      }
    }
  };
}
